/* ------------------------------------------------------------------
   Re-ativa o botão “Adicionar ao carrinho” quando o mini-cart fecha
   ------------------------------------------------------------------ */
document.addEventListener('DOMContentLoaded', () => {

  /* 1. Quem é o drawer?  ------------------------------------------ */
  const cartUI = document.querySelector('cart-drawer')
               || document.querySelector('cart-notification');
  if (!cartUI) return;               // tema sem drawer → nada a fazer

  /* 2. Função que reabilita todos os botões ------------------------ */
function resetAddButtons () {

  /* ==> sai sem fazer nada se o drawer estiver visível */
  const aberto = cartUI.hasAttribute('open')
              || cartUI.classList.contains('is-open')
              || cartUI.classList.contains('active');
  if (aberto) return;

  /* ==> percorre todos os formulários de add-to-cart */
  document.querySelectorAll('form[action^="/cart/add"]').forEach(form => {
    const btn = form.querySelector('[name="add"], button[type="submit"]');
    if (!btn) return;

    /* ------- destrava de verdade ───────── */
    btn.disabled = false;                    // Safari / iOS
    btn.removeAttribute('disabled');         // Chrome / Edge / Firefox
    btn.setAttribute('aria-disabled','false');

    btn.classList.remove('disabled','loading','sold-out');

    /* spinner fora de vista */
    btn.querySelector('.loading-overlay__spinner')?.classList.add('hidden');

    /* volta o texto padrão */
    btn.textContent = 'ADICIONAR AO CARRINHO';
  });
}


  /* 3. Escuta o evento <dialog> nativo (funciona no Dawn >= 8) ----- */
  cartUI.addEventListener('close', resetAddButtons);

  /* 4. Para temas/drawers que só trocam classe, usamos MutationObs. */
  new MutationObserver(resetAddButtons)
    .observe(cartUI, {attributes:true, attributeFilter:['open','class']});
});
/* ------------------------------------------------------------------ */
